// extracted by mini-css-extract-plugin
export default {"wrap-share":"Share_wrap-share__kDTtk"};